/**
 * Route for `quarterly-awards`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { QuarterlyAwardsPage } from "../features/quarterly-awards/QuarterlyAwardsPage";

export const quarterlyAwardsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/quarterly-awards",
	component: QuarterlyAwardsPage,
});

export default quarterlyAwardsRoute;
